module.exports = __webpack_public_path__ + "img/gf1sat.5d697df1.png";